import type ArrivedQueueItemData from "~~/api/response/data/queue/ArrivedQueueItemData";
import {DateTime} from "luxon";
import Queue, {QueuePriority} from "~/dto/queue/Queue";

export default class ArrivedQueueItem {
  queue: Queue;
  registrationNumber: string;
  callingOrder: number;
  registeredAt: DateTime;

  constructor(data: ArrivedQueueItemData) {
    this.queue = new Queue(data.queue);
    this.registrationNumber = data.registration_number;
    this.callingOrder = data.calling_order;
    this.registeredAt = DateTime.fromISO(data.registered_at);
  }

  get isInPriorityQueue() {
    return QueuePriority.Priority === this.queue.priority;
  }
}
